import Vue from 'vue';
import VueRouter from 'vue-router';
import self from '@/common/utils/global-config';
import { interceptor } from '@/common/utils/interceptor';
import * as Constants from '@/common/utils/constants';

// 各业务路由引入注册
import HomepageFunction from '@/common/router/homepage-function';
import LoginFunction from '@/common/router/login-function';
import PatientFunction from '@/common/router/patient-function';
import AppointmentFunction from '@/common/router/appointment-function';
import RechargeFunction from '@/common/router/recharge-function';
import QueryFunction from '@/common/router/query-function';
import MtaFunction from '@/common/router/mta-function';
import PhysicalFunction from '@/common/router/physical-function';
import LectureFunction from '@/common/router/lecture-function';
import OtherFunction from '@/common/router/other-function';

// 会作为首页路由页面引入配置
import Area from '@/pages/appointment/area';
import Depart from '@/pages/appointment/depart';
import Lecture from '@/pages/lecture/homepage';

// 通过重写 push、replace 方法，处理相同路由跳转时，报错问题
function original() {
  ['push', 'replace'].forEach(el => {
    const original = VueRouter.prototype[el];
    VueRouter.prototype[el] = function navigate(target, resolve, reject) {
      if (resolve || reject) {
        return original.call(this, target, resolve, reject);
      }
      return original.call(this, target).catch(() => {});
    };
  });
}

original();

Vue.use(VueRouter);
const pcEntranceArea = self.$sn.getConfig('pcEntranceArea');

let page;
let config = [];
let title = '';

if (self.$sn.utils.getHospitalId() === Constants.HOSPITAL_ID_QDGW) page = Lecture;
else {
  page = pcEntranceArea ? Area : Depart;
  config = Constants.CONFIG_COMPARE.appointment;
  title = pcEntranceArea ? '选择专家类型' : '选择医生';
}

const router = new VueRouter({
  routes: [
    {
      path: '/',
      component: page,
      beforeEnter: (to, from, next) => {
        interceptor(to, from, next, Constants.LOGIN_TYPE_NO, config, title);
      }
    },
    ...HomepageFunction,
    ...LoginFunction,
    ...PatientFunction,
    ...AppointmentFunction,
    ...RechargeFunction,
    ...QueryFunction,
    ...MtaFunction,
    ...PhysicalFunction,
    ...LectureFunction,
    ...OtherFunction
  ]
});

export default router;
